import { Button } from './Button.js'
import { Stamp, type StampVariant } from './Stamp.js'
import styles from './QueueItem.module.css'

export interface QueueItemPolicyFlag {
  code: string
  reason: string
}

export interface QueueItemProps {
  stamp: StampVariant
  title: string
  detail: string
  actionLabel: string
  onAction: () => void
  /**
   * `LGH-029` §1, `PLT-063`. Additive to `detail` — a case can be listed for
   * one reason (mismatch, ambiguity, …) **and** carry one or more policy
   * flags (over credit limit, below margin floor), and neither hides the
   * other. Each flag's own `reason` is already the complete operator-facing
   * sentence the approve-time refusal would give; nothing here re-words it.
   */
  policyFlags?: readonly QueueItemPolicyFlag[]
}

/** UI spec §2's "What needs you" row — one line of detail, one action. */
export function QueueItem({
  stamp,
  title,
  detail,
  actionLabel,
  onAction,
  policyFlags = [],
}: QueueItemProps) {
  return (
    <div className={styles['item']}>
      <div className={styles['text']}>
        <span className={styles['title']}>
          <Stamp variant={stamp} />
          {title}
        </span>
        <span className={styles['detail']}>{detail}</span>
        {policyFlags.map((flag) => (
          <span key={flag.code} className={styles['policyFlag']}>
            {flag.reason}
          </span>
        ))}
      </div>
      <Button variant="secondary" onClick={onAction}>
        {actionLabel} →
      </Button>
    </div>
  )
}
